import LocationOn from '@ixigo/icons/LocationOnFilled';
import * as Timeline from '@ixigo/iui/Timeline';
import { Skeleton } from '@repo/shared/components';
import { CabFilled } from '@repo/shared/icons';
import { NavigationHeader } from '@/components';
import { LoaderItem } from '@/components/cab-selection/loader';
import { USPHighlight } from '../-features/usp-highlight';

export const ReviewPageLoading = () => {
	const timelineItems = [
		{
			location: 'Loading...',
			icon: <LocationOn className="size-20 shrink-0 text-secondary" />,
		},
		{
			location: 'Loading...',
			icon: <CabFilled className="size-20 shrink-0 text-secondary" />,
		},
		{
			location: 'Loading...',
			icon: <LocationOn className="size-20 shrink-0 text-secondary" />,
		},
	];
	return (
		<div className="w-full flex flex-col justify-start items-center bg-tertiary">
			<header className="sticky top-0 z-10 border-b border-tertiary w-full">
				<NavigationHeader
					title="Review Booking"
					className="bg-primary"
					leftIcon={
						<Skeleton
							loading={true}
							variant="rectangular"
							className="w-full rounded-5"
							level="body-xs"
							height={24}
							width={24}
						/>
					}
					leftAction={() => {}}
				/>
				<USPHighlight />
			</header>
			<div className="w-full flex flex-col gap-y-15 items-start justify-between bg-primary p-20 pb-15">
				<div className="bg-primary flex flex-col gap-y-15 w-full">
					<div className="flex justify-around items-center border border-tertiary rounded-[15px] w-full overflow-hidden">
						<div className="w-full flex flex-col">
							<div className="flex flex-col gap-y-10 p-15">
								<Skeleton
									loading={true}
									variant="text"
									className="w-full rounded-5"
									level="h6"
								/>
								<Timeline.Root
									orientation="vertical"
									contentPosition="end"
									className="w-full overflow-hidden"
								>
									{timelineItems.map((item, index) => (
										<Timeline.Item key={index} className="relative">
											<Timeline.Separator
												indicator={item.icon}
												connector={
													<div
														className={`w-px h-full border-x border-secondary ${
															index === timelineItems.length - 1 ? 'hidden' : ''
														}`}
													/>
												}
											/>
											<Timeline.Content className="overflow-hidden">
												<div className="w-full flex flex-col gap-y-0.5">
													<Skeleton
														loading={true}
														level="body-sm"
														height={16}
														variant="text"
														className="w-10/12 rounded-5"
													/>
													<Skeleton
														loading={true}
														level="body-xs"
														height={12}
														className="w-8/12 rounded-5"
														variant="text"
													/>
												</div>
											</Timeline.Content>
										</Timeline.Item>
									))}
								</Timeline.Root>
							</div>
							<div className="w-full flex justify-between gap-x-10 items-center py-10 px-15 bg-secondary">
								<Skeleton
									loading={true}
									height={40}
									width={40}
									variant="rectangular"
									className="rounded-lg shrink-0"
								/>
								<div className="w-full flex flex-col gap-y-2.5 h-full">
									<Skeleton
										loading={true}
										level="body-md"
										height={16}
										className="rounded-5"
										variant="text"
									/>
									<Skeleton
										loading={true}
										level="body-xs"
										height={12}
										className="rounded-5"
										variant="text"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<LoaderItem />
			</div>
		</div>
	);
};
